'use strict';

/**
 * Адаптер для класса MCTWidget коллтрекинга
 * на странице необходимо подключение скрипта
 * <script type="text/javascript" src="//widget.mango-office.ru/js/c-t-w.min.js"></script>
 *
 * @param a
 * @constructor
 */
function MCTWidgetAdapter() {
    window.MCTWidget.apply(this, arguments);
    const $this = this;

    /**
     * Перезагрузка метода формирования виджета
     * заменяем телефон так как нам надо
     *
     * @param phone {string}
     */
    this.buildWidget = phone => {
        const phoneClean = phone.replace(/[() -]/g, '');
        if ($this.elem.getAttribute('href')) {
            $this.elem.setAttribute('href', 'tel:' + phoneClean);
        } else {
            let link = document.createElement('a');
            link.className = 'city-data-block__phones-link';
            link.setAttribute('href', 'tel:' + phoneClean);
            link.innerText = phone;
            $this.elem.innerHTML = '';
            $this.elem.insertBefore(link, $this.elem.firstChild);
        }
    };
}

export default class Mango {
    constructor() {
        this.elements = document.getElementsByClassName('m-call-tracking-widget');
        this.host = window.location.protocol + '//widget.mango-office.ru';
    }

    init() {
        for (let i = 0; i < this.elements.length; i++) {
            const element = this.elements[i];
            if ('true' !== element.getAttribute('init')) {
                const widget = new MCTWidgetAdapter({
                    host: this.host,
                    elem: element
                });
                widget.initWidget();
                element.setAttribute('init', 'true');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./calltracking/mango.js